// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2-Qm6","label":"Radio_label__21rNt","checkMark":"Radio_checkMark__2lMu7","disabled":"Radio_disabled__3cQZe"};